import { Check, Eye, Clock, Minus, type Icon } from '@phosphor-icons/react'

/**
 * Display mapping for `RoleAccessSection` — the icon key/level/label a cell
 * from `GET /auth/role-matrix` carries is already computed server-side
 * (`backend/app/core/role_matrix.py`); this just resolves the icon key to a
 * component + color, and a role slug to its friendly label, matching the
 * `ROLE_LABELS` idiom already used in `TeamSection.tsx`.
 */

export interface IconTone {
  Icon: Icon
  colorClass: string
}

const ICON_MAP: Record<string, IconTone> = {
  check: { Icon: Check, colorClass: 'text-emerald-600 dark:text-emerald-400' },
  eye: { Icon: Eye, colorClass: 'text-[#5e6ad2] dark:text-[#a5b4fc]' },
  clock: { Icon: Clock, colorClass: 'text-amber-600 dark:text-amber-400' },
  dash: { Icon: Minus, colorClass: 'text-muted-foreground/40 dark:text-[#62666d]' },
}

/** Falls back to the "dash" (no access) tone for an icon key this build doesn't recognize yet. */
export function iconForAccess(icon: string): IconTone {
  return ICON_MAP[icon] ?? ICON_MAP.dash
}

export const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  representative: 'Representative',
  analyst: 'Analyst',
}

/** Falls back to the raw role string for anything outside the known 5 roles. */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role
}
